export const teamManagement = {
  forbidden: {
    title: "Accesso limitato",
    desc: "Solo l'host principale può gestire il team.",
  },
  header: {
    title: "Gestione del team",
    subtitle: "Gestisci chi può accedere alla dashboard della tua struttura",
    addMember: "Aggiungi membro",
  },
  stats: {
    totalTeam: "Team totale",
    host: "Host",
    additionalMembers: "Membri aggiuntivi",
  },
  search: {
    placeholder: "Cerca per nome o email…",
  },
  loading: "Caricamento team…",
  table: {
    member: "Membro",
    email: "Email",
    role: "Ruolo",
    properties: "Strutture",
    added: "Aggiunto",
    actions: "Azioni",
    ownerBadge: "Host",
    mainHost: "Host principale",
    viewPermissions: "Visualizza funzioni consentite",
    allProperties: "Tutte",
    unassigned: "Non assegnato",
    notEditable: "Non modificabile",
    edit: "Modifica",
    delete: "Elimina",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "Nessun membro aggiuntivo",
    desc: "Usa il pulsante <strong>Aggiungi membro</strong> per invitare persone nel tuo team.",
  },
  infoBanner:
    "I membri del team accedono alla dashboard con il proprio nome utente e password. Ogni profilo ha permessi fissi e l'accesso ai dati viene applicato sul server. Il proprietario accede solo via web; pulizie e manutenzione, solo tramite app. L'<strong>host principale</strong> ha sempre accesso completo e non può essere rimosso.",
  modal: {
    createTitle: "Aggiungi membro",
    editTitle: "Modifica membro",
    nameLabel: "Nome completo",
    namePlaceholder: "es. Maria Garcia",
    emailLabel: "Indirizzo email",
    emailPlaceholder: "email@example.com",
    roleLabel: "Profilo di accesso",
    viewScope: "Ambito di visualizzazione",
    accessIncluded: "Accesso incluso",
    assignedProperties: "Strutture assegnate",
    selectedCount: "({selected} di {total} selezionate)",
    propertySearchPlaceholder: "Cerca struttura…",
    selectAll: "Seleziona tutte",
    clear: "Cancella",
    noResults: 'Nessun risultato per "{query}"',
    selectAtLeastOneHint: "Seleziona almeno una struttura per questo profilo.",
    noPropertiesWarning:
      "Non ci sono strutture disponibili da assegnare. Crea una struttura prima di salvare questo profilo.",
    passwordLabel: "Password",
    passwordOptional: "(lascia vuoto per non modificarla)",
    passwordPlaceholder: "Almeno 8 caratteri",
    confirmPasswordLabel: "Conferma password",
    confirmPasswordPlaceholder: "Ripeti password",
    showPassword: "Mostra password",
    hidePassword: "Nascondi password",
    cancel: "Annulla",
    create: "Crea membro",
    save: "Salva modifiche",
  },
  deleteModal: {
    title: "Elimina membro",
    subtitle: "Questa azione non può essere annullata",
    confirm:
      "Sei sicuro di voler rimuovere {name} dal team? Perderà immediatamente l'accesso alla dashboard.",
    cancel: "Annulla",
    delete: "Elimina",
  },
  roleInfo: {
    defaultTitle: "Permessi",
    description:
      "Questo profilo è fisso. Il suo ambito, le modalità di accesso e le strutture vengono convalidati anche sul server.",
    understood: "Ho capito",
  },
  roleDescriptions: {
    anfitrion: "Accesso completo a tutte le strutture da web e app.",
    propietario:
      "Calendari e statistiche solo per le strutture assegnate. Accesso web.",
    limpieza:
      "Avvio pulizie, attività e messaggi per le proprie strutture. Solo app.",
    mantenimiento:
      "Avvio manutenzione, attività e messaggi per le proprie strutture. Solo app.",
    fallback: "Profilo di compatibilità con accesso limitato.",
  },
  optionalHints: {
    messages:
      "Visualizzazione e risposta alle chat delle proprie strutture. Se disattivato, non vedrà i messaggi né riceverà le relative notifiche.",
  },
  toasts: {
    loadError: "Impossibile caricare il team.",
    memberAdded: "✓ Membro aggiunto al team.",
    memberUpdated: "✓ Membro aggiornato.",
    saveError: "Impossibile salvare. Riprova.",
    memberDeleted: "Membro rimosso dal team.",
    deleteError: "Impossibile rimuovere il membro.",
  },
};
